import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges, forwardRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

/**
 * åéæé®ç»ä»¶ - ä½ä¸ºåéæé®ç»{@link NpRadioGroup|RadioGroup}ä¸­çä¸ä¸ªåéæé®ä½¿ç¨
 */
@Component({
  selector: `np-radio-button`,
  templateUrl: 'radio-button.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpRadioButton),
      multi: true,
    }]
})

export class NpRadioButton implements OnInit {
  /**æ­¤åéæé®çå¼ */
  @Input() value;

  /**
   * é»è®¤ä¸ºåå½¢åéæé®
   * 
   * 'radio' - è¥ä¸ºæ­¤å¼ï¼ååéæé®ä¸ºåå½¢åéæé®
   * 
   * 'rectangle' - è¥ä¸ºæ­¤å¼ï¼ååéæé®ä¸ºé¿æ¹å½¢åéæé®
   */
  @Input() radioShape: any = 'radio';
  checked = false;
  /** æ¯å¦ç¦ç¨ */
  @Input() isDisabled = false;

  /**å½åéæé®éä¸­ç¶ææ¹åæ¶è§¦åæ­¤äºä»¶ï¼å¹¶emitå½åéä¸­çåéæé®çå¼ */
  @Output() onSelectChanged = new EventEmitter();

  ngOnInit() { }

  onChange() {
    if (!this.isDisabled) {
      this.onSelectChanged.next(this.value);
    }
  }
}

